import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { CTARow } from "@/components/CTA";
import { SITE } from "@/data/site";
import { LOCATIONS } from "@/data/locations";

export default function LocationsIndexPage() {
  return (
    <>
      <Seo
        title="Service Areas — Passport & Visa Assistance Nationwide | Travel Passport and Visa LLC"
        siteName={SITE.siteName}
        description="Passport and visa assistance for travelers across the U.S., from our Washington, DC office. Serving major metros including New York, Los Angeles, Chicago, Miami, and more. Call 866-334-8472."
      />
      <section className="grain bg-navy py-16 lg:py-24" data-testid="locations-index-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <span className="inline-block rounded-full border border-gold/40 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-gold">
            Private Service Provider
          </span>
          <h1 className="mt-5 max-w-3xl font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Where We Serve Travelers
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
            From our Washington, DC office, {SITE.name} assists travelers across the United States with passport, visa, and travel document services.
          </p>
          <CTARow light className="mt-8" testPrefix="locations-index" />
        </div>
      </section>
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {LOCATIONS.map((l, i) => (
              <Reveal key={l.slug} delay={(i % 3) * 0.07}>
                <Link
                  to={`/locations/${l.slug}`}
                  data-testid={`locations-index-${l.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-slate-200 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold/60 hover:shadow-xl hover:shadow-navy/5"
                >
                  <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-gold-dark">
                    <MapPin className="h-3.5 w-3.5" /> {l.airport}
                  </span>
                  <h2 className="mt-3 font-display text-xl font-bold text-navy group-hover:text-gold-dark">
                    {l.name}
                  </h2>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">
                    Passport and visa assistance for travelers in {l.short}.
                  </p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
